import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Wrapper, Button, Content, ContentHeader, OptionButton } from './styles';
import Utils from '../../../../utils';
import useClickOutside from '../../../../utils/customHooks/useClickOutside';

interface HeaderDropdownProps {
	buttonLabel: string;
	dropdownTitle: React.ReactNode | null;
	color: string;
	isDisabled: boolean;
	options?: HeaderDropdownOption[];
	onButtonClick?: () => void;
}

export interface HeaderDropdownOption {
	label: string;
	icon?: {
		name: string;
		width: string;
		height: string;
		isRotating?: boolean;
	};
	onClick: () => void;
}

const HeaderDropdown = ({
	buttonLabel,
	dropdownTitle,
	color,
	isDisabled,
	options,
	onButtonClick,
}: HeaderDropdownProps) => {
	const [isOpened, setIsOpened] = React.useState(false);
	const wrapperElement = React.useRef<HTMLDivElement>(null);
	useClickOutside(wrapperElement, isOpened, () => setIsOpened(false));
	const hasDropdown = options && options.length > 0;

	const handleButtonClick = () => {
		if (onButtonClick) {
			return onButtonClick();
		}

		setIsOpened(isOpened => !isOpened);
	};

	return (
		<Wrapper ref={wrapperElement}>
			<Button
				color={color}
				isOpened={isOpened}
				disabled={isDisabled}
				hasDropdown={hasDropdown}
				onClick={handleButtonClick}
			>
				<Translate value={buttonLabel} />
				{hasDropdown && Utils.getSvgIcon('iconset_right')}
			</Button>
			{isOpened && hasDropdown &&
				<Content>
					{dropdownTitle &&
						<ContentHeader>{dropdownTitle}</ContentHeader>
					}
					{options!.map(({ label, icon, onClick }, index) => (
						<OptionButton
							key={`${label}-${index}`}
							onClick={onClick}
							iconWidth={icon ? icon.width : undefined}
							iconHeight={icon ? icon.height : undefined}
							isRotatingIcon={icon ? icon.isRotating : undefined}
						>
							<Translate value={label} />
							{icon && Utils.getSvgIcon(icon.name)}
						</OptionButton>
					))}
				</Content>
			}
		</Wrapper>
	);
};

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Header/Dropdown/index.tsx